import React, { useRef, forwardRef, useState, useEffect, useMemo } from 'react'
import { THREE } from 'expo-three'

import { OBJLoader } from 'three/examples/jsm/loaders/OBJLoader';
import { MTLLoader } from 'three/examples/jsm/loaders/MTLLoader'

import modelObj from '../../../assets/enemy_bubble/enemy_ufoGreen.obj'
import modelMtl from '../../../assets/enemy_bubble/enemy_ufoGreen.mtl'

const loaderObj = new OBJLoader();
const loaderMtl = new MTLLoader();

const textureLoader = new THREE.TextureLoader()

export default forwardRef((props, ref) => {
  const fwdRef = ref || useRef()
  const [geometry, setGeometry] = useState()
  const { colorPalette = [], ...moreProps } = props

  const threeTone = textureLoader.load(require('../../../assets/threeTone.jpg'));
  threeTone.minFilter = THREE.NearestFilter;
  threeTone.magFilter = THREE.NearestFilter;
  
  const materialChassis = colorPalette[0] ? new THREE.MeshToonMaterial({ color: colorPalette[0], gradientMap: threeTone }) : new THREE.MeshLambertMaterial({ color: colorPalette[0] })
  const materialDeco = colorPalette[1] ? new THREE.MeshToonMaterial({ color: colorPalette[1], gradientMap: threeTone }) : new THREE.MeshLambertMaterial({ color: colorPalette[1] })
  const materialDome = colorPalette[3] ? new THREE.MeshToonMaterial({ color: colorPalette[3], gradientMap: threeTone }) : new THREE.MeshLambertMaterial({ color: colorPalette[3] })

  const loadObject = async () => {
    const mtl = loaderMtl.parse(modelMtl)
    mtl.preload();
    loaderObj.setMaterials(mtl)
    const obj = loaderObj.parse(modelObj)
    obj.children[0].material[0] = materialChassis// snowRoad
    obj.children[0].material[1] = materialDome// glass
    obj.children[0].material[2] = materialDeco// foliage

    obj.children[0].castShadow = true
    setGeometry(obj)
  }

  useEffect(loadObject,[])

  return useMemo(() =>
    <group
      ref={fwdRef}
      {...moreProps}
    >
      {geometry &&
        <primitive object={geometry} />
      }
    </group>
  , [geometry])
})